// The page shell: header, user menu, tab strip, language picker. This is what
// pagegrid.tpl + alltabsbody.tpl + tabs.tpl rendered on the server, drawn here
// from the /ui/session payload, after which the legacy login sequence runs
// (WB.notify.showNotifications -> WB.loadBase) exactly as it did on /base.
import shellHtml from '../views/shell.html?raw';
import { mount } from './tpl.js';
import { logout as apiLogout } from './session.js';
import * as tabs from './tabs.js';
import { installViewApi } from '../views/index.js';

let rendered = false;

export function isRendered() {
  return rendered;
}

function buildMenu(sess) {
  const ul = document.getElementById('wbUserMenu');
  if (!ul) return;
  ul.innerHTML = '';
  for (const item of sess.ui.menu) {
    const li = document.createElement('li');
    li.setAttribute('role', 'presentation');
    const a = document.createElement('a');
    a.tabIndex = -1;
    a.setAttribute('role', 'menuitem');
    a.href = item.href || '#';
    // ui.cfg menu items are inline JS strings (WB.logout(); ...), as before
    a.setAttribute('onclick', "WB.webutils.sendActivityToServer(" + JSON.stringify(item.title || item.label) + ');' + (item.onclick || ''));
    a.textContent = item.label;
    li.appendChild(a);
    ul.appendChild(li);
  }
}

function buildLanguagePicker(sess) {
  const $ = window.$;
  const source = sess.langs.map((l) => ({ text: l.name, value: l.code }));
  $('a[name=langpicker]').editable({
    value: sess.user.lang,
    source,
    success: function () {
      // strings and the UI config are per language: start over
      try {
        sessionStorage.removeItem('wb.lang.' + sess.user.lang);
      } catch (e) {
        /* ignore */
      }
      location.reload();
    },
  });
}

function publishLegacyGlobals(WB, sess) {
  // what the legacy modules used to scrape out of the server-rendered shell
  WB.session = sess;
  WB.uiConfig = {
    navstyle: sess.ui.navstyle,
    states: sess.ui.states,
    tabs: sess.ui.tabs,
    default: false,
  };
  WB.isCellbieAdmin = sess.isCellbieAdmin ? 'True' : 'False';
  WB.domainCountryCode = sess.org.country;
  WB.currentUserRole = sess.user.role;
  WB.currentUserLevel = String(sess.user.level);
  WB.currentUserLanguageCode = sess.lang;
  WB.logout = async function () {
    try {
      await apiLogout();
    } finally {
      window.location = '/login';
    }
  };
  WB.autologout = function () {
    WB.logout();
    setTimeout(function () {
      window.close();
    }, 1000);
  };
}

const INIT_LIST = [
  'purchaser', 'retail', 'quoter', 'customer', 'batchtrade', 'tracking', 'warehouse',
  'quoterreports', 'shipping', 'b2boverview', 'pricedata', 'inprogress', 'knownquality',
  'repairest', 'WFProcs', 'notify', 'eztrade', 'webutils', 'monitor', 'controllers',
  'webactivity', 'transmogrify', 'adjustment', 'lots', 'listings', 'commercialinvoice',
];

function initLegacyModules(WB) {
  // the WB.<module>.init() calls alltabsbody.tpl made
  for (const name of INIT_LIST) {
    const mod = WB[name];
    if (mod && typeof mod.init === 'function') {
      try {
        mod.init();
      } catch (e) {
        console.error('WB.' + name + '.init failed', e);
      }
    }
  }
}

export function renderShell(sess) {
  const WB = window.WB;
  const ctx = Object.assign({}, sess, {
    isCellbieAdminStr: sess.isCellbieAdmin ? 'True' : 'False',
    isAdminBody: sess.ui.body === 'tabadmin',
  });
  mount(document.getElementById('app'), shellHtml, ctx);
  document.body.classList.remove('wb-login-guest');

  publishLegacyGlobals(WB, sess);
  installViewApi(WB);
  tabs.setTabs(sess.ui.tabs);
  tabs.installLegacyHooks(WB);
  tabs.renderNav();
  buildMenu(sess);
  initLegacyModules(WB);
  buildLanguagePicker(sess);
  rendered = true;

  // The old $(document).ready in whitebox_main.js: notifications, then terms,
  // then WB.loadBase -> initEvents/setupWindow/initUIConfig (which shows the tab
  // for the current route through the hooks installed above).
  WB.notify.showNotifications(function (allNotificationCompleted) {
    if (allNotificationCompleted === true) {
      WB.loadBase();
      // the notification badge, once per page load (it used to be per tab load)
      WB.notify.initiateNotificationCall();
    } else {
      WB.logout();
    }
  });
}
